export default __webpack_public_path__ + "static/media/WD-P80 Desktop 80mm thermal printer.0387714b.jpg";